// Única constante de regra remanescente do domínio de tipos de serviço no frontend.
// O id 26 ("Outros") é identidade estável do domínio (service_provider_types) e governa a exibição/
// obrigatoriedade do campo `othersDescription`. Mantida como constante síncrona — não deve ser
// derivada do catálogo assíncrono.
export const OTHERS_SERVICE_TYPE_ID = 26;
